var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconFollowingCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68 68"
  }, props), /*#__PURE__*/React.createElement("linearGradient", {
    id: "place_svg_profile_circle_gradient",
    gradientUnits: "userSpaceOnUse",
    x1: 58.613,
    y1: 0.5638,
    x2: 22.3539,
    y2: 52.7672,
    gradientTransform: "matrix(6.123234e-17 1 1 -6.123234e-17 -2 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2D8DEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7DE7FF"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "place_svg_profile_circle",
    cx: 34,
    cy: 34,
    r: 32.5,
    strokeWidth: 3,
    stroke: "url(#place_svg_profile_circle_gradient)",
    fill: "none",
    strokeLinecap: "round"
  })));
}
export default SvgCommonIconFollowingCircle;